import { css } from 'lit';
export default css ` 
         @charset "UTF-8";
/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */
/**
   * Visible focus outline 2px inside the element on a light background
   */
/**
   * Visible focus outline 2px inside the element on a dark background
   */
/**
   * Visible focus outline for elements on a light background
   */
/**
   * Invisible focus outline for elements that need a more visible
   * focus state for high-contrast mode
   */
/**
   * Visually hidden from display
   */
/**
   * style for text ellipsis
   */
/**
   * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
   */
/* ------------------------------------*\
    #VISIBILITY UTILITIES
\*------------------------------------ */
/* Completely remove from the flow and screen readers. */
.cat-u-is-hidden {
  display: none !important;
  visibility: hidden !important;
}

/* Completely remove from the flow but leave available to screen readers. */
.cat-u-is-vishidden {
  position: absolute !important;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
}

/**
 * Hide element at sm breakpoint 
 */
@media all and (min-width: 23.4375rem) {
  .cat-u-hide-sm {
    display: none !important;
  }
}

/**
 * Hide element at sm-2 breakpoint 
 */
@media all and (min-width: 35rem) {
  .cat-u-hide-sm-2 {
    display: none !important;
  }
}

/**
 * Hide element at md breakpoint 
 */
@media all and (min-width: 48rem) {
  .cat-u-hide-md {
    display: none !important;
  }
}

/**
 * Hide element at lg breakpoint 
 */
@media all and (min-width: 60rem) {
  .cat-u-hide-lg {
    display: none !important;
  }
}

/**
 * Hide element at xl breakpoint 
 */
@media all and (min-width: 75rem) {
  .cat-u-hide-xl {
    display: none !important;
  }
}

/**
 * Show element at sm breakpoint 
 */
@media all and (max-width: 23.4375rem) {
  .cat-u-show-sm {
    display: none !important;
  }
}

/**
 * Show element at sm-2 breakpoint 
 */
@media all and (max-width: 35rem) {
  .cat-u-show-sm-2 {
    display: none !important;
  }
}

/**
 * Show element at md breakpoint 
 */
@media all and (max-width: 48rem) {
  .cat-u-show-md {
    display: none !important;
  }
}

/**
 * Show element at lg breakpoint 
 */
@media all and (max-width: 60rem) {
  .cat-u-show-lg {
    display: none !important;
  }
}

/**
 * Show element at xl breakpoint 
 */
@media all and (max-width: 75rem) {
  .cat-u-show-xl {
    display: none !important;
  }
}

/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
    #radio-FIELD
\*------------------------------------ */
/**
 * 1)
 */
:host {
  display: block;
}

/**
 * Setting hover pseudoclass styles for custom wrapper and custom radio
 */
:is(.cat-c-radio__input:not(:disabled)) + .cat-c-radio__custom-wrapper:hover, :is(.cat-c-radio__input:not(:disabled)) + .cat-c-radio__custom-wrapper:has(~ .cat-c-radio__custom-radio:hover) {
  border-color: var(--cat-theme-color-form-border);
  background-color: var(--cat-theme-color-background-default-hover);
}

/**
 * Setting active pseudoclass styles for custom wrapper and custom radio
 */
:is(.cat-c-radio__input:not(:disabled)) + .cat-c-radio__custom-wrapper:active, :is(.cat-c-radio__input:not(:disabled)) + .cat-c-radio__custom-wrapper:has(~ .cat-c-radio__custom-radio:active) {
  border: none;
  background-color: var(--cat-theme-color-button-background-active);
}

/**
 * Setting cursor styles for custom wrapper and custom radio
 */
:is(.cat-c-radio__custom-wrapper, .cat-c-radio__custom-radio) {
  cursor: pointer;
}

/*
 * Setting disabled state styles for custom wraper and custom radio
 */
:is(.cat-c-radio__input:disabled + .cat-c-radio__custom-wrapper, .cat-c-radio__input:disabled ~ .cat-c-radio__custom-radio) {
  border-color: var(--cat-theme-color-border-subtle);
  cursor: not-allowed;
}

.cat-c-radio-field {
  margin: var(--cat-radio-field-margin-top, var(--cat-space-x-small)) 0 0 0;
  padding: 0;
  position: relative;
}
:host(:first-child) .cat-c-radio-field {
  margin-block-start: 0;
}
.cat-c-radio-field .cat-c-radio__input:disabled ~ .cat-c-radio-field__label {
  color: var(--cat-theme-color-content-disabled);
  cursor: not-allowed;
}
.cat-c-radio-field:focus-visible {
  outline: none;
}

/**
 * Setting pointer events none for readonly state
 */
.cat-is-readonly,
.cat-is-loading {
  pointer-events: none;
}

/**
 * Setting the position of loader
 */
.cat-c-radio-field-loading {
  margin-block-start: var(--cat-space-x-small);
}

.cat-c-radio-field__fieldnote-loader {
  margin-inline-start: calc(var(--size-base-unit) * 4.5);
}

/**
 * Notation of radio-field 
 */
.cat-c-radio-field__required {
  color: var(--cat-theme-color-content-subtle);
  font-family: var(--cat-theme-typography-footnote-font-family);
  font-weight: var(--cat-theme-typography-footnote-font-weight);
  font-size: var(--cat-theme-typography-footnote-font-size);
  line-height: var(--cat-theme-typography-footnote-line-height);
  margin-inline-start: var(--cat-space-3x-small);
  margin-block: var(--cat-space-3x-small);
  /**
   * Disabled state for notation
   */
}
.cat-is-disabled .cat-c-radio-field__required {
  color: var(--cat-theme-color-content-disabled);
  cursor: not-allowed;
}

.cat-c-radio-field__container {
  display: flex;
  position: relative;
  align-items: flex-start;
  gap: var(--cat-space-3x-small);
  /**
  * Radio field readonly 
  */
}
.cat-c-radio-readonly .cat-c-radio-field__container {
  pointer-events: none;
}

/**
 * Inline checkbox wrapping label
 */
.cat-c-radio-field__label {
  font-family: var(--cat-theme-typography-body-font-family);
  font-weight: var(--cat-theme-typography-body-font-weight);
  font-size: var(--cat-theme-typography-body-font-size);
  line-height: var(--cat-theme-typography-body-line-height);
  color: var(--cat-radio-field-color, var(--cat-theme-color-content-strong));
  background-color: var(--cat-radio-field-color-background, var(--cat-theme-color-background-default));
  position: relative;
  display: flex;
  flex: 1;
  word-break: break-word;
  cursor: pointer;
  padding-block: calc(var(--size-base-unit) * 0.5);
}
.cat-c-radio--hidden-label .cat-c-radio-field__label {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}
.cat-is-inline .cat-c-radio-field__label {
  flex: none;
}

/**
 * Radio control input
 * 1) Make control dimensions same as outer container
 * 2) Hide native form controls
 */
.cat-c-radio__input {
  visibility: hidden;
  display: block;
  margin: 0;
  width: calc(var(--size-base-unit) * 4); /* 1 */
  height: calc(var(--size-base-unit) * 4); /* 1 */
  opacity: 0; /* 2 */
  z-index: 4;
  flex-shrink: 0;
  /**
   * Disabled state for radio input
   */
  /**
   * Focus visible for radio input
   */
  /**
   * Radio input within boxed radio field
   */
}
.cat-c-radio__input:disabled {
  cursor: not-allowed;
}
.cat-c-radio__input:focus-visible {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-offset-focus-ring, 2px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
}
.cat-c-radio-field--boxed .cat-c-radio__input {
  position: absolute;
  inset-block-start: 0; /* 1 */
  inset-inline-start: 0; /* 1 */
}

.cat-c-radio__custom-wrapper {
  position: absolute;
  display: flex;
  width: calc(var(--size-base-unit) * 4);
  height: calc(var(--size-base-unit) * 4);
  padding: var(--cat-space-3x-small);
  justify-content: center;
  align-items: center;
  gap: var(--cat-space-medium);
  border-radius: 2px;
  /**
  * Custom radio background within hovered radio input 
  */
  /**
  * Show focus ring around wrapper on keyboard focus
  */
  /**
  * Custom radio-field style in active/pressed state
  */
}
.cat-c-radio__input:hover:not(:disabled) + .cat-c-radio__custom-wrapper {
  border-color: var(--cat-theme-color-form-border);
  background-color: var(--cat-theme-color-background-default-hover);
}
.cat-c-radio-field:focus-visible .cat-c-radio__custom-wrapper {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-offset-focus-ring, 2px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
}
.cat-c-radio-field__container-active .cat-c-radio__custom-wrapper, .cat-c-radio__input:active:not(:disabled) + .cat-c-radio__custom-wrapper {
  border: none;
  background-color: var(--cat-theme-color-button-background-active);
}

/**
* Disabled focus for radio field loading state
*/
.cat-c-radio-field.cat-is-loading:focus-visible .cat-c-radio__custom-wrapper {
  outline: none;
}

/**
 * Custom radio
 * 1) Make control dimensions same as outer container
 */
.cat-c-radio__custom-radio {
  position: absolute;
  inset-block: calc(var(--size-base-unit) * 0.875) 0;
  inset-inline: calc(var(--size-base-unit) * 0.875) 0; /* 1 */ /* 1 */
  width: calc(var(--size-base-unit) * 2.25); /* 1 */
  height: calc(var(--size-base-unit) * 2.25);
  flex-shrink: 0;
  z-index: 1;
  /**
   * Radio custom radio within boxed radio field
   * 1) Vertically center align the radio in the box
   */
  /**
   * Custom radio background
   * 1) Make control dimensions same as outer container
   * 2) Stack background behind radio foreground
   */
  /**
   * Custom radio inner circle
   * 1) Position circle in center of box
   */
}
.cat-c-radio-field--boxed .cat-c-radio__custom-radio {
  position: absolute;
  inset-block-start: 9px; /* 1 */
  inset-inline-start: var(--cat-space-small);
}
.cat-c-radio__custom-radio:before {
  content: "";
  position: absolute;
  inset-block: 0; /* 1 */
  inset-inline: 0; /* 1 */ /* 1 */ /* 1 */
  z-index: 1; /* 2 */
  display: block;
  border: var(--cat-border-width-sm) solid var(--cat-theme-color-form-border);
  border-radius: 50%;
  background-color: var(--cat-theme-color-background-default);
  /**
   * Custom radio background within checked radio input
   */
  /**
   * Custom radio background inside of disabled control
   */
}
.cat-c-radio__input:checked ~ .cat-c-radio__custom-radio:before {
  background-color: var(--cat-theme-color-background-brand);
  border-color: var(--cat-theme-color-border-strong);
}
.cat-c-radio__input:disabled ~ .cat-c-radio__custom-radio:before {
  border-color: var(--cat-theme-color-border-subtle);
  background-color: var(--cat-theme-color-background-subtle);
  cursor: not-allowed;
}
.cat-is-readonly .cat-c-radio__custom-radio:before {
  border-color: var(--cat-theme-color-border-readonly);
}
.cat-c-radio__custom-radio:after {
  content: "";
  position: absolute;
  inset-block-start: 50%;
  inset-inline-start: 50%;
  width: calc(var(--size-base-unit) * 1.375);
  height: calc(var(--size-base-unit) * 1.375);
  z-index: 2;
  display: block;
  border-radius: 50%;
  transform: translate(var(--rtlTranslateX, -50%), -50%);
  background-color: var(--cat-theme-color-content-default);
  opacity: 0; /* 2 */
  flex-shrink: 0;
  /**
   * Radio inner circle within checked radio input
   * 1) Show/hide circle based on if input is checked
   */
}
.cat-c-radio__input:checked ~ .cat-c-radio__custom-radio:after {
  opacity: 1; /* 1 */
}
.cat-c-radio__input:checked:disabled ~ .cat-c-radio__custom-radio:after {
  background-color: var(--cat-theme-color-content-disabled);
}

/**
* giving border for error state when input is checked and unchecked
*/
:not(.cat-is-readonly, .cat-is-loading, .cat-is-disabled).cat-is-error .cat-c-radio__input:checked ~ .cat-c-radio__custom-radio:before {
  border: 2px solid var(--cat-theme-color-border-utility-error);
}
:not(.cat-is-readonly, .cat-is-loading, .cat-is-disabled).cat-is-error .cat-c-radio__custom-radio:before {
  border: 2px solid var(--cat-theme-color-border-utility-error);
}

/**
* Setting the styles of radio field for loading and readonly state
*/
.cat-c-radio-field:is(.cat-is-readonly, .cat-is-loading) .cat-c-radio__input:checked ~ .cat-c-radio__custom-radio:before {
  border: var(--cat-border-width-sm) solid var(--cat-theme-color-border-readonly);
  background-color: var(--cat-theme-color-background-default);
}

.cat-is-loading .cat-c-radio__input:checked ~ .cat-c-radio__custom-radio:after {
  opacity: 0;
}

/**
* Setting the Position of fieldnote
* 1)Setting the color of fieldnote and warningnote
* 2) Setting the color of fieldnote and warningnote in disabled state
*/
.cat-c-radio--fieldnote {
  display: inline-flex;
  align-items: center;
}
.cat-is-loading .cat-c-radio--fieldnote {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
  /* 1 */
}
.cat-c-radio--fieldnote slot[name=field-note],
.cat-c-radio--fieldnote slot[name=warning] {
  color: var(--cat-theme-color-content-default);
}
.cat-is-disabled .cat-c-radio--fieldnote slot[name=field-note],
.cat-is-disabled .cat-c-radio--fieldnote slot[name=warning] {
  cursor: not-allowed;
  color: var(--cat-theme-color-content-disabled); /* 1 */
}
.cat-is-disabled .cat-c-radio--fieldnote slot[name=error] {
  cursor: not-allowed;
  color: var(--cat-theme-color-content-disabled); /* 1 */
}
.cat-c-radio--fieldnote:has(slot[name=field-note]) {
  margin-inline-start: calc(var(--size-base-unit) * 3.8);
}

/* Flex container for both Icon and Fieldnote */
.cat-c-radio-field__fieldnote-container {
  display: flex;
  gap: var(--cat-space-small);
  margin-inline-start: var(--cat-space-x-small);
}

/**
* Setting the margin block start to 0 for field note
*/
cat-field-note {
  --cat-field-note-margin-block-start: 0;
}

/**
* Adding styles to error and warning icons
*/
.cat-is-loading .cat-c-radio-field__icon {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
  /* 1 */
}
.cat-is-disabled .cat-c-radio-field__icon {
  cursor: not-allowed;
}

.cat-c-radio-field:not(.cat-c-radio-field--has-error) :is([part=error-icon], .cat-c-radio-field__error-note), .cat-c-radio-field:not(.cat-c-radio-field--has-warning) :is([part=warning-icon], .cat-c-radio-field__warning-note), .cat-c-radio-field:not(.cat-c-radio-field--has-field-note) .cat-c-radio-field__field-note {
  display: none;
}
`;
